import { RpcBaseData } from './rpc-base';

/**
 * RPC Observable result context.
 */
export interface RpcObservableResultContext {
    /**
     * Source manifest name.
     */
    sourceName?: string;

    /**
     * Source path name with instance id.
     */
    sourceSubName?: string;

    /**
     * version.
     */
    sourceVersion?: string;
}

/**
 * The RPC Observable Result packet format.
 */
export interface RpcObservableResult<TResult extends RpcObservableResultContext, TError extends RpcObservableResultContext>
        extends RpcBaseData {

    /**
     * Result identity.
     */
    id: number;

    /**
     * Result data.
     */
    result?: TResult;

    /**
     * Error data.
     */
    error?: TError;
}
